import { ModelResource } from './resource';
import { Vendor } from '../models';

export class Vendors extends ModelResource<Vendor> {
  model = Vendor;

  resourcePath = 'v1/deductions/vendors';
}
